<template>
    <div class="about__section">
        <h3>Storage</h3>
        <dl>
            <dt>IndexedDB</dt>
            <dd>
                <button class="btn btn-default btn-sm"
                        @click="testIndexedDb()">
                    Test
                </button>
            </dd>
        </dl>
    </div>
</template>

<script>
import logFactory from '@/libraries/DigiTickets/Logging/logFactory';
import { container } from '@/container';

export default {
    name: 'DebugStorageSection',

    methods: {
        testIndexedDb() {
            const logger = logFactory('DebugModal');

            container.dataStoreTester
                .test()
                .then(() => {
                    window.alert('IndexedDB is working.');
                })
                .catch((error) => {
                    window.alert(error.toString());
                    logger.warn(
                        'IndexedDB not available (test button):',
                        error
                    );
                });
        },
    },
};
</script>
